import { LabelType } from "@/hooks/useConfig";
import { BCPLayer } from "@/Utils/hierarchy";

import { BreakdownDataProps } from "../chartUtils";
import { getDisplayLabel } from "./displayUtils";

export const calculateLayerTotal = (
  data: BreakdownDataProps,
  layersWithData: BCPLayer[],
  layers: BCPLayer[],
  legendStates: Record<string, boolean>,
  label: LabelType,
  type: "spend" | "revenue",
  revenueLabel: string = "Revenue"
): number => {
  return layersWithData.reduce((sum, layer) => {
    const i = layers.indexOf(layer);
    const layerLegend = `${getDisplayLabel(layer, label)} Marketing ${type === "revenue" ? revenueLabel : "Spend"}`;
    const value = type === "revenue" ? data.revenue[i] : data.spend[i];
    return sum + (legendStates[layerLegend] && value !== null && value !== undefined ? value : 0);
  }, 0);
};
